"use strict";

var _context16;
var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _uuid = require("uuid");
var _getXsrfHeader = require("./getXsrfHeader");
var _getQueryString = require("./getQueryString");
var _responseError = require("./responseError");
_forEachInstanceProperty(_context16 = _Object$keys2(_responseError)).call(_context16, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _responseError[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _responseError[key];
    }
  });
});
var _requestError = require("./requestError");
var _responseBuilder = require("./defaultBuilders/responseBuilder");
var _json = _interopRequireDefault(require("./defaultBuilders/json"));
var _excluded = ["headers", "applyTransactionId", "applyXsrfHeader"];
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context14, _context15; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context14 = ownKeys(Object(t), !0)).call(_context14, function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context15 = ownKeys(Object(t))).call(_context15, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var REQUEST_ID = 'X-Request-ID';
var TRANSACTION_ID = 'X-Transaction-ID';
var CONTENT_TYPE = 'Content-Type';
var JSON_CONTENT_TYPE = 'application/json';
var URLENCODED_CONTENT_TYPE = 'application/x-www-form-urlencoded';
var DEFAULT_OPTIONS = {
  credentials: 'include'
};
var cache = {};
var getTransactionalHeaders = function getTransactionalHeaders(applyTransactionId) {
  // apply it by default but leave an option to disable
  if (applyTransactionId === false) {
    return {};
  }
  return (0, _defineProperty2.default)((0, _defineProperty2.default)({}, TRANSACTION_ID, (0, _uuid.v4)()), REQUEST_ID, (0, _uuid.v4)());
};
var getXsrfHeaders = function getXsrfHeaders(applyXsrfHeader) {
  // apply it by default but leave an option to disable
  if (applyXsrfHeader === false) {
    return {};
  }
  return (0, _getXsrfHeader.getXsrfHeader)();
};
var getContentTypeHeader = function getContentTypeHeader(method, data) {
  if (method === 'GET' || method === 'DELETE') {
    return {};
  }
  if (data && data instanceof FormData) {
    return {};
  }
  return (0, _defineProperty2.default)({}, CONTENT_TYPE, 'application/json; charset=utf-8');
};
var getMonolithError = function getMonolithError(response) {
  var monolithHeaderResponse = response.headers.get('x-json');
  return monolithHeaderResponse ? JSON.parse(monolithHeaderResponse).error[0] : null;
};
var constructUrl = function constructUrl(url) {
  var _context;
  if (typeof url === 'string') {
    return url;
  }
  if (!url.queryParams || (0, _keys.default)(url.queryParams).length === 0) {
    return url.path;
  }
  return (0, _concat.default)(_context = "".concat(url.path, "?")).call(_context, (0, _getQueryString.getQueryString)(url.queryParams));
};
var applyDefaults = function applyDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var method = arguments.length > 1 ? arguments[1] : undefined;
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var headers = options.headers,
    applyTransactionId = options.applyTransactionId,
    applyXsrfHeader = options.applyXsrfHeader,
    rest = (0, _objectWithoutProperties2.default)(options, _excluded);
  var credentialsOptions = !options.excludeCredentials ? DEFAULT_OPTIONS : undefined;
  return _objectSpread(_objectSpread(_objectSpread({
    method: method
  }, credentialsOptions), rest), {}, {
    headers: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getContentTypeHeader(method, data)), getTransactionalHeaders(applyTransactionId)), getXsrfHeaders(applyXsrfHeader)), headers)
  });
};
var constructBody = function constructBody(data, headers) {
  var _context2, _context3;
  if ((0, _typeof2.default)(data) !== 'object' || !headers[CONTENT_TYPE]) {
    return data;
  }
  if ((0, _indexOf.default)(_context2 = headers[CONTENT_TYPE]).call(_context2, JSON_CONTENT_TYPE) !== -1) {
    return (0, _stringify.default)(data);
  }
  if ((0, _indexOf.default)(_context3 = headers[CONTENT_TYPE]).call(_context3, URLENCODED_CONTENT_TYPE) !== -1) {
    return (0, _getQueryString.getQueryString)(data);
  }
  return data;
};
var request = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(method, url, responseCreator, options, data) {
    var navigationOccurred, setNavigationOccurred, endpoint, config, controller, response, _context4, monolithError, _context5;
    return _regenerator.default.wrap(function _callee$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          navigationOccurred = false;
          setNavigationOccurred = function setNavigationOccurred() {
            navigationOccurred = true;
          };
          window.addEventListener('pagehide', setNavigationOccurred);
          endpoint = constructUrl(url);
          config = applyDefaults(options, method, data);
          if (data) {
            (0, _assign.default)(config, {
              body: constructBody(data, config.headers)
            });
          }
          if (options !== null && options !== void 0 && options.timeoutInMs && window.AbortController) {
            controller = new AbortController();
            (0, _setTimeout2.default)(function () {
              return controller.abort();
            }, options.timeoutInMs);
            (0, _assign.default)(config, {
              signal: controller.signal
            });
          }
          _context6.prev = 7;
          _context6.next = 10;
          return fetch(endpoint, config);
        case 10:
          response = _context6.sent;
          _context6.next = 18;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](7);
          if (!(_context6.t0 instanceof DOMException)) {
            _context6.next = 17;
            break;
          }
          throw new _requestError.RequestError('Request timed out', _objectSpread(_objectSpread({}, config), {}, {
            url: url.toString()
          }), _context6.t0);
        case 17:
          throw new _requestError.RequestError('Fetch threw TypeError', _objectSpread(_objectSpread({}, config), {}, {
            url: url.toString(),
            navigationOccurred: navigationOccurred
          }), _context6.t0);
        case 18:
          _context6.prev = 18;
          window.removeEventListener('pagehide', setNavigationOccurred);
          return _context6.finish(18);
        case 21:
          if (response.ok) {
            _context6.next = 24;
            break;
          }
          window.removeEventListener('pagehide', setNavigationOccurred);
          throw new _responseError.ResponseError((0, _concat.default)(_context4 = "Received ".concat(response.status, " error from ")).call(_context4, url), response, _objectSpread(_objectSpread({}, config), {}, {
            url: url.toString()
          }));
        case 24:
          monolithError = getMonolithError(response);
          if (!(monolithError !== null)) {
            _context6.next = 28;
            break;
          }
          window.removeEventListener('pagehide', setNavigationOccurred);
          throw new _responseError.ResponseError((0, _concat.default)(_context5 = "Received ".concat(monolithError.message, " error from ")).call(_context5, url), response, _objectSpread(_objectSpread({}, config), {}, {
            url: url.toString()
          }));
        case 28:
          _context6.prev = 28;
          _context6.next = 31;
          return responseCreator(response);
        case 31:
          _context6.t1 = _context6.sent;
          _context6.t2 = response.headers;
          _context6.t3 = response.status;
          return _context6.abrupt("return", {
            data: _context6.t1,
            headers: _context6.t2,
            status: _context6.t3
          });
        case 37:
          _context6.prev = 37;
          _context6.t4 = _context6["catch"](28);
          throw new _responseError.ResponseError('Error parsing response body', response, _objectSpread(_objectSpread({}, config), {}, {
            url: url.toString(),
            navigationOccurred: navigationOccurred
          }), _context6.t4);
        case 40:
          _context6.prev = 40;
          window.removeEventListener('pagehide', setNavigationOccurred);
          return _context6.finish(40);
        case 43:
        case "end":
          return _context6.stop();
      }
    }, _callee, null, [[7, 13, 18, 21], [28, 37, 40, 43]]);
  }));
  return function request(_x, _x2, _x3, _x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
var getCacheKey = function getCacheKey(endpoint, key) {
  var _context7;
  return (0, _concat.default)(_context7 = "".concat(endpoint)).call(_context7, key ? "#".concat(key) : '');
};
var _default = exports.default = {
  get: function () {
    var _get = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(url, options) {
      var responseCreator,
        _args2 = arguments;
      return _regenerator.default.wrap(function _callee2$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            responseCreator = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : (0, _responseBuilder.responseCreatorBuilder)(_json.default.creator);
            return _context8.abrupt("return", request('GET', url, responseCreator, options));
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee2);
    }));
    function get(_x6, _x7) {
      return _get.apply(this, arguments);
    }
    return get;
  }(),
  cachedGet: function () {
    var _cachedGet = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(url, options) {
      var responseCreator,
        endpoint,
        cacheKey,
        response,
        _args3 = arguments;
      return _regenerator.default.wrap(function _callee3$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            responseCreator = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {
              creator: (0, _responseBuilder.responseCreatorBuilder)(_json.default.creator)
            };
            endpoint = constructUrl(url);
            cacheKey = getCacheKey(endpoint, responseCreator.key);
            if (!cache[cacheKey]) {
              cache[cacheKey] = request('GET', endpoint, responseCreator.creator, options);
            }
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            response = cache[cacheKey];
            response.catch(function () {
              cache[cacheKey] = undefined;
            });
            return _context9.abrupt("return", response);
          case 7:
          case "end":
            return _context9.stop();
        }
      }, _callee3);
    }));
    function cachedGet(_x8, _x9) {
      return _cachedGet.apply(this, arguments);
    }
    return cachedGet;
  }(),
  cacheClean: function cacheClean(url, creatorKey) {
    var endpoint = constructUrl(url);
    var cacheKey = getCacheKey(endpoint, creatorKey);
    cache[cacheKey] = undefined;
  },
  post: function () {
    var _post = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(url, data, options) {
      var responseCreator,
        _args4 = arguments;
      return _regenerator.default.wrap(function _callee4$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            responseCreator = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : (0, _responseBuilder.responseCreatorBuilder)(_json.default.creator);
            return _context10.abrupt("return", request('POST', url, responseCreator, options, data));
          case 2:
          case "end":
            return _context10.stop();
        }
      }, _callee4);
    }));
    function post(_x10, _x11, _x12) {
      return _post.apply(this, arguments);
    }
    return post;
  }(),
  patch: function () {
    var _patch = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5(url, data, options) {
      var responseCreator,
        _args5 = arguments;
      return _regenerator.default.wrap(function _callee5$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            responseCreator = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : (0, _responseBuilder.responseCreatorBuilder)(_json.default.creator);
            return _context11.abrupt("return", request('PATCH', url, responseCreator, options, data));
          case 2:
          case "end":
            return _context11.stop();
        }
      }, _callee5);
    }));
    function patch(_x13, _x14, _x15) {
      return _patch.apply(this, arguments);
    }
    return patch;
  }(),
  put: function () {
    var _put = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee6(url, data, options) {
      var responseCreator,
        _args6 = arguments;
      return _regenerator.default.wrap(function _callee6$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            responseCreator = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : (0, _responseBuilder.responseCreatorBuilder)(_json.default.creator);
            return _context12.abrupt("return", request('PUT', url, responseCreator, options, data));
          case 2:
          case "end":
            return _context12.stop();
        }
      }, _callee6);
    }));
    function put(_x16, _x17, _x18) {
      return _put.apply(this, arguments);
    }
    return put;
  }(),
  delete: function () {
    var _delete2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee7(url, options) {
      var responseCreator,
        _args7 = arguments;
      return _regenerator.default.wrap(function _callee7$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            responseCreator = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : (0, _responseBuilder.responseCreatorBuilder)(_json.default.creator);
            return _context13.abrupt("return", request('DELETE', url, responseCreator, options));
          case 2:
          case "end":
            return _context13.stop();
        }
      }, _callee7);
    }));
    function _delete(_x19, _x20) {
      return _delete2.apply(this, arguments);
    }
    return _delete;
  }()
};
//# sourceMappingURL=httpClient.js.map